/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DiscountTypeEnum } from './DiscountTypeEnum';
import {
    DiscountTypeEnumFromJSON,
    DiscountTypeEnumFromJSONTyped,
    DiscountTypeEnumToJSON,
    DiscountTypeEnumToJSONTyped,
} from './DiscountTypeEnum';
import type { Product } from './Product';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
    ProductToJSONTyped,
} from './Product';

/**
 * 
 * @export
 * @interface OfferProduct
 */
export interface OfferProduct {
    /**
     * 
     * @type {number}
     * @memberof OfferProduct
     */
    id: number;
    /**
     * 
     * @type {Product}
     * @memberof OfferProduct
     */
    product: Product;
    /**
     * 
     * @type {boolean}
     * @memberof OfferProduct
     */
    isTransfer?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OfferProduct
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof OfferProduct
     */
    discount: number;
    /**
     * 
     * @type {DiscountTypeEnum}
     * @memberof OfferProduct
     */
    discountType: DiscountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof OfferProduct
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof OfferProduct
     */
    firstPayment?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof OfferProduct
     */
    timeDiscounts: Array<number>;
}



/**
 * Check if a given object implements the OfferProduct interface.
 */
export function instanceOfOfferProduct(value: object): value is OfferProduct {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('product' in value) || value['product'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('discount' in value) || value['discount'] === undefined) return false;
    if (!('discountType' in value) || value['discountType'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('timeDiscounts' in value) || value['timeDiscounts'] === undefined) return false;
    return true;
}

export function OfferProductFromJSON(json: any): OfferProduct {
    return OfferProductFromJSONTyped(json, false);
}

export function OfferProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferProduct {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'product': ProductFromJSON(json['product']),
        'isTransfer': json['isTransfer'] == null ? undefined : json['isTransfer'],
        'quantity': json['quantity'],
        'discount': json['discount'],
        'discountType': DiscountTypeEnumFromJSON(json['discountType']),
        'total': json['total'],
        'firstPayment': json['firstPayment'] == null ? undefined : json['firstPayment'],
        'timeDiscounts': json['timeDiscounts'],
    };
}

export function OfferProductToJSON(json: any): OfferProduct {
    return OfferProductToJSONTyped(json, false);
}

export function OfferProductToJSONTyped(value?: OfferProduct | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'product': ProductToJSON(value['product']),
        'isTransfer': value['isTransfer'],
        'quantity': value['quantity'],
        'discount': value['discount'],
        'discountType': DiscountTypeEnumToJSON(value['discountType']),
        'total': value['total'],
        'firstPayment': value['firstPayment'],
        'timeDiscounts': value['timeDiscounts'],
    };
}

